/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { HighFrequencyBackupResourceType } from '../models/HighFrequencyBackupResourceType';
import { HighFrequencyBackupSchedules } from '../models/HighFrequencyBackupSchedules';

export class HighFrequencyBackupPolicyPlan {
  /**
  * Resource types to backup.
  */
  'resourceTypes': Array<HighFrequencyBackupResourceType>;
  /**
  * List of backup schedules. Each schedule specifies a backup frequency, retention period, and vault. 
  */
  'backupSchedules': Array<HighFrequencyBackupSchedules>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resourceTypes",
      "baseName": "resourceTypes",
      "type": "Array<HighFrequencyBackupResourceType>",
      "format": ""
    },
    {
      "name": "backupSchedules",
      "baseName": "backupSchedules",
      "type": "Array<HighFrequencyBackupSchedules>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return HighFrequencyBackupPolicyPlan.attributeTypeMap;
  }

  public constructor() {
  }
}

